import { useMutation } from "@tanstack/react-query";
import ApiClient from "@/lib/api-client";
import { SendMessageDto } from "../lib/api-client-generated-types";

export function useContact() {
  const {
    mutate: contact,
    isPending: isPendingContact,
    isError: isErrorContact,
    error: errorContact,
    isSuccess: isSuccessContact,
  } = useMutation({
    mutationFn: (data: SendMessageDto) => ApiClient.contact(data),
  });

  return {
    contact,
    isPendingContact,
    isErrorContact,
    errorContact,
    isSuccessContact,
  };
}
